import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseFormFieldApi, CourseFromGroupApi } from "api";
import { ApplicationFormSchema, FormFieldSchema } from "components/templates/AddApplicationFormGroupModal/ApplicationForm";

const fetchGroups = (categoryId: number): AxiosPromise<CourseFromGroupApi[]> => {
  return api.get<CourseFromGroupApi[]>(endpoints.CATEGORY_FORM_GROUPS.GET_ALL(categoryId));
};

const addGroup = (categoryId: number, body: Pick<ApplicationFormSchema, "name" | "description">): AxiosPromise<number> => {
  return api.post<number>(endpoints.CATEGORY_FORM_GROUPS.ADD_GROUP(categoryId), body);
};

const updateGroup = (
  categoryId: number,
  groupId: number,
  body: Pick<ApplicationFormSchema, "name" | "description">,
): AxiosPromise<void> => {
  return api.put<void>(endpoints.CATEGORY_FORM_GROUPS.UPDATE_GROUP(categoryId, groupId), body);
};

const deleteGroup = (categoryId: number, groupId: number): AxiosPromise<void> => {
  return api.delete(endpoints.CATEGORY_FORM_GROUPS.DELETE_GROUP(categoryId, groupId));
};

const addField = (categoryId: number, groupId: number, body: FormFieldSchema): AxiosPromise<CourseFormFieldApi> => {
  return api.post<CourseFormFieldApi>(endpoints.CATEGORY_FORM_GROUPS.ADD_FIELD(categoryId, groupId), body);
};

const updateField = (
  categoryId: number,
  groupId: number,
  fieldId: number,
  body: FormFieldSchema,
): AxiosPromise<void> => {
  return api.put<void>(endpoints.CATEGORY_FORM_GROUPS.UPDATE_FIELD(categoryId, groupId, fieldId), body);
};

const deleteField = (categoryId: number, groupId: number, fieldId: number): AxiosPromise<void> => {
  return api.delete(endpoints.CATEGORY_FORM_GROUPS.DELETE_FIELD(categoryId, groupId, fieldId));
};

export const categoryFormGroupsApi = {
  fetchGroups,
  addGroup,
  updateGroup,
  deleteGroup,
  addField,
  updateField,
  deleteField,
};
